var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-mask"},[_c('div',{staticClass:"modal-wrapper",on:{"click":_vm.close}},[_c('search-box',{on:{"close":_vm.close}}),_c('search-result',{attrs:{"results":_vm.results}}),_c('footer',{staticClass:"mt-3"},[_c('kbd',[_vm._v("esc")]),_vm._v(" © Nasarawa State University, Transcript "+_vm._s(_vm.year)+" ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }